import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  ChevronDown,
  ChevronUp,
  UserPlus,
  LogIn,
  Home,
  Shield,
  CreditCard,
  History,
  ShoppingCart,
  Settings,
  AlertTriangle,
  Key,
  RefreshCw,
  HelpCircle,
} from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";

const helpTopics = [
  {
    id: 1,
    title: "Beginner's Guide: Sign Up & Login",
    icon: LogIn,
    description: "Learn how to create an account and sign in",
  },
  {
    id: 2,
    title: "Beginner's Guide: User Verification Process",
    icon: Shield,
    description: "Overview of the complete verification process",
  },
  {
    id: 3,
    title: "User Verification Step 1: User Registration",
    icon: UserPlus,
    description: "Complete your user registration",
  },
  {
    id: 4,
    title: "User Verification Step 2: Address Registration",
    icon: Home,
    description: "Register your residential address",
  },
  {
    id: 5,
    title: "User Verification Step 3: KYC",
    icon: Shield,
    description: "Complete KYC identity verification",
  },
  {
    id: 6,
    title: "User Verification Step 4: Wallet Creation",
    icon: Settings,
    description: "Create your digital wallet",
  },
  {
    id: 7,
    title: "Fellas Card – Node Card Screen Guide",
    icon: CreditCard,
    description: "Navigate the card screen interface",
  },
  {
    id: 8,
    title: "How to Purchase a Fellas Card",
    icon: ShoppingCart,
    description: "Purchase your Fellas Card",
  },
  {
    id: 9,
    title: "How to Register Your Card",
    icon: CreditCard,
    description: "Activate and register your physical card",
  },
  {
    id: 10,
    title: "Top Up Your Fellas Card",
    icon: RefreshCw,
    description: "Add funds to your card balance",
  },
  {
    id: 11,
    title: "Guide to Setting Your PIN",
    icon: Key,
    description: "Set up your secure PIN number",
  },
  {
    id: 12,
    title: "Card Status Change Guide",
    icon: Settings,
    description: "Lock, unlock, or change card status",
  },
  {
    id: 13,
    title: "Guide to Reporting a Stolen Card",
    icon: AlertTriangle,
    description: "Report and block a lost or stolen card",
  },
  {
    id: 14,
    title: "View Your Fellas Card Transaction History",
    icon: History,
    description: "Check your transaction history",
  },
  {
    id: 15,
    title: "View Profile",
    icon: UserPlus,
    description: "Access and manage your profile",
  },
  {
    id: 16,
    title: "Password Change Guide",
    icon: Key,
    description: "Update your account password",
  },
];

export default function Help() {
  const navigate = useNavigate();

  const handleTopicClick = (topicId) => {
    navigate(`/help/${topicId}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/home")} />

      <div className="max-w-md mx-auto px-3 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6 text-center">
          <div className="flex justify-center mb-3">
            <div className="p-3 bg-primary/10 rounded-full">
              <HelpCircle className="w-8 h-8 text-primary" />
            </div>
          </div>
          <h1 className="text-2xl font-bold">Help Center</h1>
          {/* <p className="text-sm text-muted-foreground mt-2">
            Fellas Card User Guide
          </p> */}
        </div>

        {/* Help Topics */}
        <div className="space-y-3">
          {helpTopics.map((topic) => {
            const Icon = topic.icon;

            return (
              <Card
                key={topic.id}
                className="bg-card/80 cursor-pointer hover:bg-accent/30 transition-colors"
                onClick={() => handleTopicClick(topic.id)}
              >
                <CardContent className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-primary/10">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-sm">{topic.title}</p>
                      <p className="text-xs text-muted-foreground mt-0.5">
                        {topic.description}
                      </p>
                    </div>
                    <ChevronDown className="w-5 h-5 text-muted-foreground rotate-[-90deg]" />
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Contact Support */}
        {/* <Card className="mt-6 bg-primary/5">
          <CardContent className="p-6">
            <div className="text-center space-y-3">
              <h3 className="font-semibold">Need More Help?</h3>
              <p className="text-sm text-muted-foreground">
                Our support team is here to assist you
              </p>
              <Button 
                className="w-full"
                onClick={() => window.location.href = 'mailto:support@fellascard.com'}
              >
                Contact Support
              </Button>
            </div>
          </CardContent>
        </Card> */}
      </div>

      <BottomBar />
    </div>
  );
}
